"use server";

/** `passwordRecovery` returns Boolean with no selection set (D34). */
type PasswordRecoveryData = { passwordRecovery: boolean | null };

import { gql } from "@/lib/lecturehub/client";
import { friendlyMessage } from "@/lib/lecturehub/errors";
import { getRequestDict } from "@/lib/i18n-server";
import { M_PASSWORD_RECOVERY } from "@/lib/lecturehub/operations";
import type { FormState } from "@/lib/actions/result";

export type RecoveryState = FormState;

export async function recoveryRequestAction(
  _prev: RecoveryState,
  formData: FormData,
): Promise<RecoveryState> {
  const email = String(formData.get("email") ?? "").trim();
  const t = (await getRequestDict()).errors;
  if (!email) return { ok: false, error: t.emailRequired };
  try {
    await gql<PasswordRecoveryData>(
      M_PASSWORD_RECOVERY,
      { email },
      { asGuest: true, cache: "no-store" },
    );
    return { ok: true };
  } catch (err) {
    return { ok: false, error: friendlyMessage(err, t) };
  }
}
